class IngredientsSlider extends HTMLElement {
  constructor() {
    super();
    this.swiperEl = this.querySelector('.ingredients-slider__swiper');
    this.textItems = this.querySelectorAll('.ingredients-slider__text');
    this.swiper = null;
    this.onBlockSelect = this.onBlockSelect.bind(this);
  }

  connectedCallback() {
    if (!this.swiperEl) return;
    this.initSwiper();
    this.addEventListener('shopify:block:select', this.onBlockSelect);
  }

  disconnectedCallback() {
    this.removeEventListener('shopify:block:select', this.onBlockSelect);
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  initSwiper() {
    const slideCount = this.swiperEl.querySelectorAll('.swiper-slide').length;

    this.swiper = new Swiper(this.swiperEl, {
      slidesPerView: 'auto',
      centeredSlides: true,
      roundLengths: true,
      loop: slideCount > 1,
      initialSlide: 0,
      speed: 500,
      spaceBetween: 39.5,
      breakpoints: {
        768: { spaceBetween: 60 },
        1024: { spaceBetween: 99 },
      },
      navigation: {
        nextEl: this.querySelector('.ingredients-slider__arrow--next'),
        prevEl: this.querySelector('.ingredients-slider__arrow--prev'),
      },
      on: {
        init: () => this.updateActiveText(),
        slideChange: () => this.updateActiveText(),
      },
    });
  }

  updateActiveText() {
    if (!this.swiper || !this.textItems.length) return;
    const activeSlide = this.swiper.slides[this.swiper.activeIndex];
    if (!activeSlide) return;
    const activeIndex = Number(activeSlide.dataset.slideIndex);

    this.textItems.forEach((item) => {
      const isActive = Number(item.dataset.slideIndex) === activeIndex;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
  }

  onBlockSelect(event) {
    if (!this.swiper) return;
    const slide = event.target.closest('.swiper-slide');
    if (!slide) return;
    this.swiper.slideToLoop(Number(slide.dataset.slideIndex));
  }
}

if (!customElements.get('ingredients-slider')) {
  customElements.define('ingredients-slider', IngredientsSlider);
}
